import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { userProfileAPIUrls } from '../data';
import { UserProfile } from '../types';

type Response = {
  success: boolean;
  message: string;
  data: UserProfile;
};

type Return = UserProfile;

export type GetUserProfile = {
  response: Response;
  return: Return;
};

export const getUserProfile = withLogger(async (): Promise<Return> => {
  const url = userProfileAPIUrls.get;

  const {
    data: { data },
  } = await authServiceAxiosClient.get<Response>(url);
  return data;
});
